import { render, staticRenderFns } from "./VehiclesPie.vue?vue&type=template&id=5235dd9c&scoped=true"
import script from "./VehiclesPie.vue?vue&type=script&lang=js"
export * from "./VehiclesPie.vue?vue&type=script&lang=js"
import style0 from "./VehiclesPie.vue?vue&type=style&index=0&id=5235dd9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5235dd9c",
  null
  
)

export default component.exports